'use strict'

import $ from 'jquery'
import './modernizr-custom.min'
import * as AnimatedCircles from '../modules/infographics/infographics'
import Modals from '../modules/modals/modals'
import Tabs from '../modules/tabs/tabs'
import Swiper from 'swiper'
import './header'
import './youtube'

window.$ = $
window.jQuery = $

$(() => {
  new Modals()
  new Tabs()
  new AnimatedCircles.AnimatedCircles()

  var mySwiper = new Swiper('.swiper-container', {
    pagination: {
      el: '.swiper-pagination'
    },
    on: {
      click: function () {
        this.slideNext()
      }
    },
    grabCursor: true,
    loop: true
  })
})
